import React, { useEffect, useState } from 'react'
import { IoIosArrowRoundBack, IoIosArrowRoundForward, IoIosPersonAdd } from 'react-icons/io';
import { RotatingLines } from 'react-loader-spinner';
import { useSearchParams } from 'react-router-dom';
import { useGlobalContext } from '../../../context/stateContext';
import { useAuth } from '../../../context/Auth';
import ExportData from '../../../components/ExportData';
import SortableTableHeader from '../../../components/Table/SortableTableHeader';

const PrintInterbranchReport = () => {
    const [searchParams] = useSearchParams();
    
  const branch = searchParams.get("branch");
  const startDate = searchParams.get("start_date");
  const endDate = searchParams.get("end_date");
  const transferType = searchParams.get('transfer_type')
  
  const { requestWithAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [creditList, setCreditList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [tableData, setTableData] = useState([])
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");


  const handleSort = (key) => {
    setCurrentPage(1);
    if (sortBy === key) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(key);
      setSortOrder("desc");
    }
  };

  const sortParam = sortBy ? `&sort_by=${sortBy}&sort_order=${sortOrder}` : "";


  const fetchCreditList = async (page_size, search_query, current_page) => {
    setLoading(true);
    try {
      const data = await requestWithAuth(
        `/report/interbranch?page=${current_page}&pageSize=${page_size}&search=${search_query}&branch=${branch}&startDate=${startDate}&endDate=${endDate}&transferType=${transferType}${sortParam}`,
        "GET"
      );
      setCreditList(data?.results);
      setNextPage(data?.next);
      setPrevPage(data?.prev);
      setTotalPages(Math.ceil(data?.count / pageSize));
    } catch (error) {
      console.error("Error fetching list:", error);
    } finally {
      setLoading(false);
    }
  };

  const getTableData = async (page_size, search_query, current_page) => {
    setLoading(true);
    try {
      const data = await requestWithAuth(
        `/report/interbranch?page=${current_page}&pageSize=100000000000000000000000000000&search=${search_query}&branch=${branch}&startDate=${startDate}&endDate=${endDate}&transferType=${transferType}${sortParam}`,
        "GET"
      );
      setTableData(data?.results);
      
    } catch (error) {
      console.error("Error fetching list:", error);
    } finally {
      setLoading(false);
    }
  };

  const filterCreditList = (search_query) => {
    setSearch(search_query);
    setCurrentPage(1); // Reset to page 1 whenever search query changes
  };

  const handleNextPage = () => {
    if (nextPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (prevPage) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalNumbersToShow = 3; // Number of pages to show around the current page
    const totalPagesToShow = 5; // Total pages to show at start and end

    let startPage = Math.max(1, currentPage - totalNumbersToShow);
    let endPage = Math.min(totalPages, currentPage + totalNumbersToShow);

    // Always show the first page
    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    // Show the numbers around the current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Always show the last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers.map((number) => (
      <button
        key={number}
        onClick={() => number !== "..." && handlePageClick(number)}
        className={
          number === currentPage
            ? "border border-[#979797] bg-gradient-to-b from-white to-[#dcdcdc] py-[0.5rem] px-[1rem]"
            : "py-[0.5rem] px-[1rem]"
        }
      >
        {number}
      </button>
    ));
  };

  useEffect(() => {
    fetchCreditList(pageSize, search, currentPage);
    getTableData(pageSize, search, currentPage);
  }, [search, currentPage, pageSize, sortBy, sortOrder]);

  
  return (
    <div className="p-[20px]">
        <div className="py-[32px] flex items-center justify-between ">
        <div className="flex items-center gap-3">
          <IoIosPersonAdd className="text-[19px]" />
          <h4 className="text-[19px]">
            <b>Report </b> - Interbranch Report
          </h4>
        </div>
        
      </div>

      <div className="border border-[#ddd] bg-white">
        <div className="p-[20px]">
            <h5 className="my-[2px] text-[17px]">Interbranch</h5>
        </div>
        <div className="p-[20px]">
            <div className="p-[20px] border border-[#ddd]">
                <div className="pt-[20px] flex justify-between mb-[20px]">
                    <div className=" flex items-center gap-5">
                    <ExportData tableData={tableData} fileName="Interbranch Report" />
                    <div className="flex items-center gap-2">
                        <b>Show:</b>
                        <select
                        name=""
                        id=""
                        onChange={(e) => setPageSize(e.target.value)}
                        className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                        >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        </select>
                    </div>
                    </div>
                    <div className="flex items-center gap-3">
                    <b>Filter:</b>
                    <input
                        type="text"
                        placeholder="Type to filter..."
                        onChange={(e) => filterCreditList(e.target.value)}
                        className="outline-none border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                    />
                    </div>
                </div>
                <div className="overflow-auto ">
                    <table className="border-collapse w-full">
                    <thead>
                        <tr>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Source Branch
                        </th>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Destination Branch
                        </th>
                        <SortableTableHeader
                            label="Quantity"
                            fieldKey="quantity"
                            sortBy={sortBy}
                            sortOrder={sortOrder}
                            onSort={handleSort}
                            thClassName="border-b border-t border-[#bbb] !py-[12px] !px-[20px]"
                        />
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Total Cost
                        </th>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Total Items
                        </th>
                        <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                            Posted By
                        </th>
                        
                        <SortableTableHeader
                            label="Posted Date"
                            fieldKey="created_at"
                            sortBy={sortBy}
                            sortOrder={sortOrder}
                            onSort={handleSort}
                            thClassName="border-b border-t border-[#bbb] !py-[12px] !px-[20px]"
                        />
                        
                        </tr>
                    </thead>
                    {!loading && (
                        <tbody>
                        {creditList?.map((item, index) => (
                            <tr key={index} className="text-center">
                            <td className="text-center border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.branch}
                            </td>
                            <td className="text-center border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.destination_branch}
                            </td>
                            <td className=" text-center border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.quantity}
                            </td>
                            <td className="text-center border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.total_cost}
                            </td>
                            <td className="text-center border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.total_items}
                            </td>

                            <td className="text-center border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.recorded_by}
                            </td>
                            
                            <td className="text-center border-b border-[#bbb] py-[12px] px-[20px]">
                                {item?.created_at}
                            </td>

                            
                            </tr>
                        ))}
                        </tbody>
                    )}
                    </table>
                    {loading && (
                    <div className="flex items-center justify-center py-10">
                        <RotatingLines
                        visible={true}
                        height="30"
                        width="30"
                        color="black"
                        strokeColor="black"
                        strokeWidth="5"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        />
                    </div>
                    )}
                    {creditList?.length <= 0 && !loading && (
                    <p className="text-center py-5">No data availabe in table</p>
                    )}
                    <div className="flex justify-between pt-[20px]">
                    <p className="text-[12px] text-[#888]">
                        Showing {currentPage} of {totalPages} pages
                    </p>
                    <div className="flex items-center gap-2">
                        <IoIosArrowRoundBack
                        className="text-[25px]"
                        onClick={handleNextPage}
                        />
                        {renderPageNumbers()}
                        <IoIosArrowRoundForward
                        className="text-[25px]"
                        onClick={handlePreviousPage}
                        />
                    </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

    </div>
  )
}

export default PrintInterbranchReport